import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LoaderService } from "src/app/loader.service";
import { catchError, map, mergeMap } from "rxjs/operators";
import { throwError } from "rxjs";
import { CustomErrorHandler } from "src/app/core/custom-error-handler";
import { AuthService } from "src/app/core/auth/auth.service";
import { AppConfig } from "src/config/app.config";
import {policyPosttData} from "src/app/addpolicy/sellpolicyData.model";
import { Router } from "@angular/router";
import { PolicyStatus } from 'src/app/core/policyStatus.model';

@Component({
  selector: "app-payu-response",
  templateUrl: "./payu-response.component.html",
  styleUrls: ["./payu-response.component.css"],
})
export class PayuResponseComponent implements OnInit {
  transactionStatus: boolean = false;
  transactionId: string;
  responsemessage: any;
  _apiUrl: string;
  policyNo: string;
  policyStatus: any;
  policyDetails = {};
  isSuccess: boolean = false;
  buyPolicyInProgress: boolean;
  isPolicyDocCreated: boolean = false;
  productInfo: string;

  constructor(private _activatedroute: ActivatedRoute,
    private authService: AuthService,
    private appConfig: AppConfig,
    private errorHandler: CustomErrorHandler,
    private loaderService: LoaderService,
    private router: Router,) {
    this._apiUrl = appConfig.baseUrl;
    this.policyStatus = PolicyStatus;
    this.productInfo = (localStorage.getItem("productinfo"));
    this.transactionStatus = (this._activatedroute.snapshot.paramMap.get("txnstatus")).toLowerCase() == 'success' ? true : false;
    this.responsemessage = (this._activatedroute.snapshot.paramMap.get("txnstatus")).toLowerCase() == 'success' ? "Payment Completed Successfuly!" : this._activatedroute.snapshot.paramMap.get("txnstatus");
    this.transactionId = this._activatedroute.snapshot.paramMap.get("txnid");
    if (this.transactionStatus==true && this.productInfo=='Online policy transaction')
    {
      this.getPolicyNumber(this.transactionId);
    }
  }

  ngOnInit(): void { 
  }

  getPolicyNumber(transactionId: string) {
    this.authService.get(this._apiUrl + '/api/v1/PolicyDetails/GetPolicyNumber/' + transactionId).subscribe(response => {
      if (response) {
        this.policyNo = response.policyNo;
        if (this.transactionStatus== true && response.policyDocPath != null)
          {
            this.errorHandler.handleCustomInfo(
              "Policy Punched Successfully! Please check your mail for Policy Document!")
          }
          else if (this.transactionStatus== true && response.policyDocPath == null)
          {
          this.updatePolicyStatus() 
          this.buyPolicy();
          }
      }
    }, (error) => {
      console.error(error);
    });
  }

  buyPolicy() {
    let timerId;
    timerId = setTimeout(() => {
      this.loaderService.show();
    }, 300);
    ;
    var result: any;
    this.authService
      .export(
        this._apiUrl +
        "/api/v1/DownLoadPage/policyNo/"+this.transactionId
      )
      .pipe(
        map((response) => {
          if (response != null) {
            this.isPolicyDocCreated = true;
          } else {
            this.errorHandler.handleCustomInfo(
              "Policy Punched Successfully! Generating policy document is failed, Please download from Manage Policy !"
            )
          }
        }),
        mergeMap(() =>
          this.authService
            .get(
              this._apiUrl +
              "/api/v1/PolicyDetails/sendmail/policyId/"+this.transactionId
            )
            .pipe(
              catchError((error) =>
                this.errorHandler.handleCustomInfo(
                  "Policy document failed to send via Email,Please Download Later!")
              )
            )
        ),
        map((response) => {
          if (response != null) {
            this.isSuccess = true;
            this.isPolicyDocCreated = true;
            this.loaderService.hide();
          }
        }),
        // If there is an exception posting policy break the execution.
        catchError((error) => {
          this.errorHandler.handleCustomInfo(error.error.error);
          this.buyPolicyInProgress = false;
          console.log(
            "Something went wrong while punching policy! Please contact system administrator"
          );
          return throwError(error);
        })
      )
      .subscribe(() =>
        console.log("policy punched successfully. Good job :)")
      );
  }

  download() {
    this.authService
      .export(
        this._apiUrl +
        "/api/v1/DownLoadPage/policyNo/" + this.transactionId
      )
      .subscribe((data) => saveAs(data, this.transactionId + `_report.pdf`));
  }

  updatePolicyStatus() {
    this.policyDetails = {
      id: this.transactionId,
      statusId: this.policyStatus.Active
    }
    this.authService.put(this._apiUrl + '/api/v1/PolicyDetails/PolicyStatusUpdate', this.policyDetails).subscribe(response => {
      this.policyDetails = {};
    }, (error) => {
      console.error(error);
      this.isSuccess = false;
    });
  }
}
